import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
	refereeInfo: [],
	loading: false,
	loadingSubmit: false
};

export default function refereeInfoPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_REFEREE_INFO_REQUEST:
		case ActionTypes.GET_REFEREE_INFO_ERROR:
		case ActionTypes.GET_REFEREE_INFO_SUCCESS:
		case ActionTypes.SUBMIT_REFEREE_INFO_REQUEST:
		case ActionTypes.SUBMIT_REFEREE_INFO_ERROR:
		case ActionTypes.SUBMIT_REFEREE_INFO_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_REFEREE_INFO_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_REFEREE_INFO_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
